'use client';

import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import { appEnvironment, isProdEnvironment, isQAEnvironment } from 'utils/environment';
import { datadogLogs } from '@datadog/browser-logs';
import { ONETRUST_CATEGORIES, onConsentChange } from 'libs/oneTrust';

let isInitialized = false;

const CLIENT_TOKEN = 'pub317a64fae7f026ae28320e9f4ff61dda';

const IGNORED_ERRORS: Array<(message: string) => boolean> = [
  msg => msg.startsWith('csp_violation'),
  msg => msg === 'Uncaught "Script error."',
  msg => msg.includes('Object Not Found Matching Id:'),
];

function isIgnoredError(message: string | undefined): boolean {
  return !!message && IGNORED_ERRORS.some(check => check(message));
}

export function DatadogRumInit() {
  useEffect(() => {
    if ((isProdEnvironment() || isQAEnvironment()) && !isInitialized) {
      datadogRum.init({
        applicationId: 'ff55cbb4-68d6-4469-af91-6c9ca257e53b',
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'chime-com',
        env: appEnvironment,
        allowedTracingUrls: [/https:\/\/.*\.chime\.com/],
        version: process.env.NEXT_PUBLIC_GIT_COMMIT_SHA,
        trackUserInteractions: false,
        trackResources: true,
        trackLongTasks: true,
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        defaultPrivacyLevel: 'mask-user-input',
        beforeSend: event => {
          if (event.type === 'error' && isIgnoredError(event?.error?.message)) {
            return false;
          }
          return true;
        },
      });

      datadogLogs.init({
        clientToken: CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'chime-com',
        env: appEnvironment,
        version: process.env.NEXT_PUBLIC_GIT_COMMIT_SHA,
        beforeSend: log => {
          if (isIgnoredError(log?.message)) {
            return false;
          }
          return true;
        },
      });

      onConsentChange(activeGroups => {
        const consent = activeGroups.includes(ONETRUST_CATEGORIES.PERFORMANCE) ? 'granted' : 'not-granted';
        datadogRum.setTrackingConsent(consent);
        datadogLogs.setTrackingConsent(consent);
      });

      datadogRum.startSessionReplayRecording();
      isInitialized = true;
    }
  }, []);

  return null;
}
